module.exports = __webpack_public_path__ + "img/cogwheel-svgrepo-com.0e7ee90e.svg";